"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/KPFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_127)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_127`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-5.04004 0H30.96V24H-5.04004V0Z",
					fill: "#91DC5A"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-5.04004 0H30.96V24H-5.04004V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-5.04004 0H30.96V4.01319H-5.04004V0ZM-5.04004 19.9368H30.96V23.9493H-5.04004V19.9368Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-5.04004 5.60706H30.96V18.3497H-5.04004V5.60706Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.31641 16.6083C10.8615 16.6083 12.9247 14.5451 12.9247 12C12.9247 9.45492 10.8615 7.39172 8.31641 7.39172C5.77133 7.39172 3.70813 9.45492 3.70813 12C3.70813 14.5451 5.77133 16.6083 8.31641 16.6083Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.31437 7.36841L9.35297 10.5474H12.7003L9.99156 12.5193L11.0302 15.7123L8.31437 13.7333L5.6056 15.7053L6.6442 12.5193L3.93542 10.5474H7.28279L8.31437 7.36841Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_127`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as KPFlag };
